export default "__VITE_ASSET__BKnJlucD__"